<template>
  <div>
    <ModalAccount
      v-if="accountList"
      ref="ModalAccount"
      :account="accountList"
      @action="selectAccount"
    ></ModalAccount>
    <modalcart v-model="dialog" />
    <v-snackbar
      v-model="alert.show"
      timeout="2000"
      right
      top
      :color="alertColor"
    >
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="hideAlert">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-app-bar color="#0043FF" flat app height="70" class="header-frame "> 
        <div class id="brand-bar">
          <router-link to="/" class="d-none d-sm-block d-xs-none">
            <v-img
              width="160"
              class="img-logo"
              src="/assets/icons/logo-banni-3.svg"
            ></v-img>
          </router-link>
          <router-link to="/" :class="$router.name == 'home' ? 'd-none' : 'd-block'" class="  d-sm-none pr-3">
            <!-- <v-img
              width="80"
              class="img-logo"
              src="/assets/icons/logo-banni.svg"
            ></v-img> -->
            <v-icon size="40" color="#fff">mdi-home</v-icon>
          </router-link>
        </div>
        <!-- <v-menu v-if="false" :close-on-content-click="false" offset-y :nudge-width="1024">
            <template v-slot:activator="{ on, attrs }">
           
              <v-btn title="Kategori" text class="white--text px-0" v-bind="attrs" v-on="on">
                <v-icon class="mr-0 mr-md-3">mdi-book</v-icon> 
              </v-btn>
            </template>
            <v-list>
              <categoryVue />
            </v-list>
          </v-menu>-->

        <div id="feature-bar">
          <v-col class="mt-0 px-0 px-md-3 mx-3" id="search-bar">
            <v-form @submit.prevent="cari" role="form">
              <v-text-field 
                v-model="search_text"
                hide-details
                placeholder="Pencarian"
                append-icon="mdi-magnify"
                single-line
                solo 
                class="rounded-pill text-caption text-sm-body-2"
                @click:append="cari"
              ></v-text-field>
            </v-form>
          </v-col>

          <!-- <div class="pl-2 pr-2 d-block d-xs-block d-sm-none" id="mini-search-bar">
          <v-btn
            fab
            x-small
            class="mt-md-n2 bg-transparent"
            elevation="0"
            @click="searchDrawer = true"
          >
            <v-img width="20" src="/assets/icons/search-icon.svg"></v-img>
            <v-icon class="text-h5 black--text">mdi-magnify</v-icon>
          </v-btn>
        </div>
            -->
        </div>
        <!-- <template v-if="isAuth">
            <a
              title="Toko Saya"
              class="text-deco white--text mr-3"
              @click="gotoMyStore"
              v-if="
                ['seller', 'stockist', 'reseller'].includes(
                  userData.user_type || ''
                )
              "
            >
              <span class="pr-2 ml-n1 d-block d-md-none">
                <v-img width="32" src="/assets/icons/icon-toko.svg"></v-img>
              </span>
              <span class="d-none d-md-block">Toko Saya</span>
            </a>
            <a
              title="Buka Toko"
              href="javascript:void(0)"
              class="text-deco white--text mr-3"
              @click="$router.push({ name: 'buka-toko' })"
              v-else
            >
              <span class="pr-2 ml-n1 d-block d-md-none">
                <v-icon class="text-h5 yellow-lighten-1--text"
                  >mdi-store</v-icon
                >
              </span>
              <span class="d-none d-md-block">Buka Toko</span>
            </a>
          </template> -->
        <div v-if="isAuth" class="pl-2 pr-2 d-sm-block" id="cart-bar">
          <router-link :to="{ name: 'cart' }">
            <v-btn fab x-small class="mt-md-n2 bg-transparent" elevation="0">
              <v-img width="5" contain src="/assets/icons/icon-cart.svg"></v-img>
            </v-btn>
            <div class="white rounded-xl badge-cart" v-if="cartProduk(cartData) > 0">
              <div
                class="black--text text-center font-size-13 font-weight-bold"
              >
                {{ cartProduk(cartData) }}
              </div>
            </div>
          </router-link>
        </div>
        <v-menu
          dark
          offset-y
          class="d-none d-sm-block d-xs-none pl-2"
          id="user-bar"
          v-if="isAuth"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              class="mt-md-n2 px-0 bg-transparent"
              id="userbtn-bar"
              elevation="0"
            >
              <div class="font-weight-bold">
                <span class="white--text d-none d-sm-block d-xs-none pl-2">{{
                  userData ? userData.user_username : ""
                }}</span>
                <div class="d-block d-sm-none d-xs-block">
                  <!-- <v-img width="24" src="/assets/icons/user.svg"></v-img> -->
                      <!-- <v-avatar size="35"
                          color="#fff"
                        > -->
                          <v-icon size="40" color="#fff">
                            mdi-account-circle
                          </v-icon>
                        <!-- </v-avatar> -->
                </div>
              </div>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list dark color="white">
            <v-list-item link @click.native="gotoProfile">
              <!-- <v-icon class="pr-3 grey--text text--darken-1">mdi-account</v-icon> -->
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Profil</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <v-list-item link @click.native="gotoTransaction">
              <span>
                <!-- <v-icon class="pr-3 grey--text text--darken-1">mdi-format-list-bulleted</v-icon> -->
              </span>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-1"
                  >Transaksi</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click.native="changeAccount" v-if="accountList">
              <!-- <v-icon class="pr-3 grey--text text--darken-1">mdi-account-details-outline</v-icon> -->
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Ganti Akun</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click.native="gotoMyStore"
              v-if="
                ['seller', 'stockist', 'reseller'].includes(userData.user_type)
              "
            >
              <span class="pr-2 ml-n1">
                <!-- <v-img width="32" src="/assets/icons/icon-toko.svg"></v-img> -->
              </span>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Toko Saya</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item link @click.native="gotoHelp">
              <span>
                <v-icon class="pr-3 grey--text text--darken-1">mdi-format-list-bulleted</v-icon>
              </span>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-1"
                  >Bantuan</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item link @click.native="onLogout">
              <!-- <v-icon class="pr-3 grey--text text--darken-1">mdi-exit-to-app</v-icon> -->
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Logout</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <template v-else>
          <v-menu
            dark
            offset-y
            class="d-none d-sm-none d-xs-block"
            id="unauthuser-bar"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                class="mt-md-n2 px-0 bg-transparent d-block d-sm-none d-xs-block"
                id="userbtn-bar"
                elevation="0"
              >
                <div class="font-weight-bold">
                  <div class="d-block d-sm-none d-xs-block">
                    <v-img
                      width="40"
                      src="/assets/icons/user-no-pading.svg"
                    ></v-img>
                  </div>
                </div>
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list dark color="white">
              <v-list-item>
                <v-list-item-content>
                  <router-link
                    :to="{ name: 'login' }"
                    text
                    class="mt-md-n2 px-0 text-deco"
                  >
                    <v-btn text color="black">
                      <div class="font-weight-bold black--text">
                        <span class="text-capitalize">Masuk</span>
                      </div>
                    </v-btn>
                  </router-link>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <router-link
                    :to="{ name: 'register' }"
                    text
                    class="mt-md-n2 px-0 text-deco"
                  >
                    <v-btn text color="black">
                      <div class="font-weight-bold">
                        <span class="text-capitalize">Daftar</span>
                      </div>
                    </v-btn>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-list-item>
                <v-list-item-content>
                  <a
                    @click.prevent="gotoHelp"
                    text
                    class="mt-md-n2 px-0 text-deco"
                  >
                    <v-btn text color="black">
                      <div class="font-weight-bold">
                        <span class="text-capitalize">Bantuan</span>
                      </div>
                    </v-btn>
                  </a>
                </v-list-item-content>
              </v-list-item> -->
            </v-list>
          </v-menu>

          <div class="d-none d-xs-none d-sm-flex" id="user-bar">
            <router-link
              :to="{ name: 'login' }"
              text
              class="mt-md-n2 px-0 text-deco"
            >
              <v-btn text color="white">
                <div class="font-weight-bold">
                  <span class="text-capitalize pr-1">Masuk</span>
                </div>
              </v-btn>
            </router-link>
            <v-divider vertical class="mt-md-n2" color="white"></v-divider>
            <router-link
              :to="{ name: 'register' }"
              text
              class="ml-3 mt-md-n2 px-0 text-deco"
            >
              <v-btn text color="white">
                <div class="font-weight-bold">
                  <span class="text-capitalize pr-1">Daftar</span>
                </div>
              </v-btn>
            </router-link>
            <!-- <v-divider vertical class="mt-md-n2" color="black"></v-divider> -->
            <!-- <a
              @click.prevent="gotoHelp"
              text
              class="ml-3 mt-md-n2 px-0 text-deco"
            >
              <v-btn text color="white">
                <div class="font-weight-bold">
                  <span class="text-capitalize pr-1">Bantuan</span>
                </div>
              </v-btn>
            </a> -->
          </div>
        </template> 
    </v-app-bar>
    <!-- <v-app-bar style="margin-top:90px" height="70" light class="header-frame bg-dark"> </v-app-bar> -->
    <!-- <v-navigation-drawer
        v-model="categoryDrawer"
        location="bottom"
        temporary
        style="z-index:20"
      >
        <v-list 
        ></v-list>
    </v-navigation-drawer>-->

    <!-- <v-navigation-drawer left v-model="categoryDrawer" app  temporary floating id="menu-drawer-bar" >
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ userData ? userData.user_name : "" }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-cart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Keranjang</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>-->

    <v-navigation-drawer
      v-model="searchDrawer"
      app
      left
      floating
      width="100%"
      id="search-drawer-bar"
    >
      <v-form @submit.prevent="cari" role="form" class="py-0 px-3">
        <v-text-field
          flat
          background-color="white"
          v-model="search_text"
          hide-details
          placeholder="Ketik pencarian di sini"
          class="black--text text-caption text-sm-body-2"
          height="40"
        >
          <v-icon
            slot="prepend-inner"
            color="black"
            class="font-weight-bold p-3"
            @click="clearSearch"
            >mdi-arrow-left</v-icon
          >
          <v-icon
            slot="append"
            class="primary--text font-weight-bold p-3"
            @click="cari"
            >mdi-magnify</v-icon
          >
        </v-text-field>
      </v-form>

      <h5 class="my-2 pt-3 px-3" v-if="false">PENCARIAN POPULER</h5>
      <v-list nav dense v-if="false">
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-title>HP Canggih Cek</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Jamu Langsing</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Masker Kain</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ModalAccount from "@/views/store/login/ModalChooseAccount";
// import categoryVue from "../../category.vue";

export default {
  components: {
    ModalAccount,
    // categoryVue
  },
  data() {
    return {
      drawer: false,
      searchDrawer: false,
      dialog: false,
      categoryDrawer: false,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
    };
  },
  computed: {
    ...mapState("auth", ["isAuth", "userData", "accountList"]),
    ...mapState(["alert"]),
    ...mapState("cart", ["cartData"]),
    userType() {
      if (this.userData) return this.userData.userType;
      return "";
    },
    showCategory() {
      return !this.$route.path.includes("search");
    },
    alertColor() {
      switch (this.alert.type) {
        case "success":
          return "primary";
        case "warning":
          return "yellow";
        default:
          return "red";
      }
    },
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapMutations(["hideAlert"]),
    ...mapMutations("auth", ["success"]),
    ...mapActions("cart", ["getCart"]),
    ...mapMutations("cart", ["setCart"]),

    changeAccount() {
      this.$refs.ModalAccount.modalShow();
    },
    selectAccount(data) {
      this.success(data);
      location.reload();
    },
    wdrawer() {
      if (window.matchMedia("(min-width: 600px)").matches) {
        this.drawer = false;
      }
    },
    gotoBukaToko() {
      this.$router.push({ name: "buka-toko" });
    },
    gotoProfile() {
      this.$router.push({
        name: "profile",
      });
    },
    gotoMyStore() {
      // let routeData = this.$router.resolve({ name: "seller-dashboard" });
      // window.open(routeData.href, "_blank");
      this.$router.push({
        name: "seller-dashboard",
      });
    },
    gotoTransaction() {
      this.$router.push("/transaction").catch(() => {});
    },
    gotoHelp() {
      window.location.href = process.env.VUE_APP_CHAT;
      return false;
    },
    onLogout() {
      this.logout().then(() => {
        this.$router.push({
          name: "login",
        });
      });
    },
    cari() {
      if (this.search_text) {
        let link = this.search_text
          .toString()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, "")
          .replace(/--+/g, "-");
        this.$router.push({
          path: "/search",
          query: {
            search: link,
            type: "product",
          },
        });
      }
    },
    clearSearch() {
      this.searchDrawer = false;
    },
    cartProduk(data) {
      let count = 0;
      data.forEach((el) => {
        el.cart_detail.forEach(() => {
          count += 1;
        });
      });
      return count;
    },
  },
  watch: {
    $route(val) {
      if (val.name == "search") {
        this.search_text = val.query.search || "";
      } else {
        this.search_text = "";
      }
    },
  },
  created() {
    if (this.isAuth) {
      this.getCart();
    } else {
      this.setCart({ data: [], pagination: {} });
    }
    window.addEventListener("resize", this.wdrawer);
  },
  destroyed() {
    window.removeEventListener("resize", this.wdrawer);
  },
};
</script>

<style lang="scss" scoped>
#feature-bar {
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: auto;
  // padding-left: 25px;
}

.small-logo {
  // background: #fff;
  width: 65px;
  height: 40px;
  padding: 6px 8px;
  border-radius: 4px;

  .v-image {
    display: block;
    margin: 0 auto;
  }
}

#mini-search-bar {
  .v-image {
    .v-image__image {
      background-size: 20px !important;
    }
  }
}

#search-drawer-bar {
  display: none;
}

@media (max-width: 599px) {
  #cart-bar,
  #message-bar,
  #mini-search-bar {
    padding-left: 7px !important;
    padding-right: 7px !important;
  }
  #search-drawer-bar {
    display: flex;
  }
}
.invert {
  filter: brightness(1) invert(1);
}
</style>
 